export default {
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  CREATE_CATEGORY(state, category) {
    state.categories.categories.push(category);
  }
};
